import ROS from '../components/RevealOnScroll';
import { useState } from "react";
import { useTranslation } from 'react-i18next';
import Contact from '../components/Contact';
import michal_image from '../img/mf2.png';

import motherboardImage from '../img/mother-board.jpg';

export default function Inserat({ name = "", focus = "", requirements = "", image , positionInfo = ""}) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="sm:flex justify-center px-4">
      <div className="bg-white bg-opacity-90 backdrop-blur-md rounded-xl shadow-md mt-8 max-w-5xl w-full overflow-hidden border border-gray-200 ring-1 ring-gray-100 transition-all duration-300">

        {/* Header */}
        <div className="bg-orange-50 p-6 rounded-t-xl bg-cover bg-center bg-opacity-40 "   style={{  backgroundImage: `url(${image})`, }}>
          <div className="inline-block bg-black bg-opacity-70 px-2 rounded">
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-100" style={{ textShadow: "0 1px 3px rgba(0,0,0,0.7)" }} >
                {name}
            </h1>
        </div>
        </div>

        {/* Collapsible content */}
        <div className={`relative transition-all duration-500 ${isOpen ? "" : "max-h-[320px] overflow-hidden"}`}>

          {/* Full or previewed content */}
          <div className="p-6 text-gray-800">

            <section>
              <h2 className="text-2xl font-semibold border-b-2 border-orange-200 pb-1 mb-4">{t("focus")}</h2>
              <p className="px-4 whitespace-pre-wrap text-xl leading-relaxed" dangerouslySetInnerHTML={{ __html: focus }} />
            </section>

            <ROS> <section>
              <h2 className="text-2xl font-semibold border-b-2 border-orange-200 pb-1 mb-4 pt-4">{t("requirements")}</h2>
              <p className="px-4 whitespace-pre-wrap text-xl leading-relaxed" dangerouslySetInnerHTML={{ __html: requirements }} />
            </section> </ROS>

            <ROS> <section className='pb-4'>
              <h2 className="text-2xl font-semibold border-b-2 border-orange-200 pb-1 mb-4 pt-2">{t("pos_info")}</h2>
              <p className="px-4 whitespace-pre-wrap text-xl leading-relaxed" dangerouslySetInnerHTML={{ __html: positionInfo }} />
            </section> </ROS>

            <section className="pt-2 border-t border-gray-200">
              <ROS> <h2 className="text-2xl font-semibold mb-4">{t("intr_est")}</h2> </ROS>
              <Contact
                name="Ing. Michal Feilhauer, Ph.D."
                tel="+420 732 988 303"
                mail="feilhauer.m@sefos.cz"
                titul={t("boss_title")}
                img={michal_image}
                inverse={true}
              />
            </section>

            {/* Toggle Button inside the gradient */}
            {!isOpen && (
            <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-white to-transparent z-10 flex items-end justify-center p-4">
                <button
                onClick={() => setIsOpen(true)}
                className="px-5 py-2 font-medium text-center text-white bg-orange-700 rounded-lg hover:bg-orange-800 focus:outline-none flex items-center gap-2 z-20"
                >
                {t("more")}
                <span className="transform transition-transform">▼</span>
                </button>
            </div>
            )}
            

            {isOpen && (
            <div className="flex justify-center pt-4">
                <button
                onClick={() => setIsOpen(false)}
                className="px-5 py-2 font-medium text-center text-white bg-orange-700 rounded-lg hover:bg-orange-800 focus:outline-none flex items-center gap-2 z-20"
                >
                {t("less")}
                <span className="transform rotate-180 transition-transform">▼</span>
                </button>
            </div>
            )}
            </div>
        </div>
      </div>
    </div>
  );
}